import React, {Component} from "react";

class MainMessage extends Component {
    componentDidMount() {
        require("./css/MainMessage.css");
    }
    render() {
        return (
            <div className="Main_Message_Area">
                <div className="Main_Message_Container">
                    {this.props.children}
                    
                </div>
            </div>
        )
    }
}
export default MainMessage;
